// document.addEventListener("DOMContentLoaded",()=>{
//     const listLabel = document.querySelectorAll('#bss-b2b-register-form .bss-b2b-rf-field label:not([for="privacy-policy"]):not([type="hidden"]):not([for="state-field"])');
//     const listInput = document.querySelectorAll('#bss-b2b-register-form .bss-b2b-rf-field input:not([type="checkbox"]):not([type="submit"]):not([type="hidden"])');
// })
if(BSS_B2B && window.location.pathname === '/pages/company-registration'){
    let interval = setInterval(() => {
        let fields = document.querySelectorAll('#bss-b2b-register-form .bss-b2b-rf-field');
        if(fields && fields.length){
            clearInterval(interval)
            fields.forEach(element => {
                const label = element.querySelector("label");
                const input = element.querySelector('input:not([type="checkbox"])');
                if(!label || !input) return;
                input.placeholder = label.textContent.replace('*', '').trim();
                label.style.display = 'none';
            })
        }
        
    }, 100);
    setTimeout(()=>{clearInterval(interval)}, 3000)

}

